import * as types from '../ActionTypes/ClassesActionTypes';

export class ClassesActionCreators {
    // get profile classes
    static getClassesRequest = (profileId, completionCallback) => ({
        type: types.GET_CLASSES_REQUEST,
        meta: { profileId, completionCallback },
    });

    static getClassesSuccess = (classes, offsetId, offsetDate) => ({
        type: types.GET_CLASSES_SUCCESS,
        payload: { classes, offsetId, offsetDate },
    });

    static getClassesFailed = response => ({
        type: types.GET_CLASSES_FAILED,
        payload: response,
    });

    // load more profile classes
    static loadMoreClassesRequest = (profileId, offsetId, offsetDate) => ({
        type: types.LOAD_MORE_CLASSES_REQUEST,
        meta: { profileId, offsetId, offsetDate },
    });

    static loadMoreClassesSuccess = (classes, offsetId, offsetDate) => ({
        type: types.LOAD_MORE_CLASSES_SUCCESS,
        payload: { classes, offsetId, offsetDate },
    });

    static loadMoreClassesFailed = payload => ({
        type: types.LOAD_MORE_CLASSES_FAILED,
        payload,
    });

    // get profile classes by a particular date
    static getClassesByDateRequest = (profileId, offsetId, offsetDate, dateFilter) => ({
        type: types.GET_CLASSES_BY_DATE_REQUEST,
        meta: { profileId, offsetId, offsetDate, dateFilter },
    });

    static getClassesByDateSuccess = payload => ({
        type: types.GET_CLASSES_BY_DATE_SUCCESS,
        payload,
    });

    static getClassesByDateFailed = payload => ({
        type: types.GET_CLASSES_BY_DATE_FAILED,
        payload,
    });

    // get profile classes by date range
    static getClassesByDateRangeRequest = (startDate, endDate) => ({
        type: types.GET_CLASSES_BY_DATE_RANGE_REQUEST,
        meta: { startDate, endDate },
    });

    static getClassesByDateRangeSuccess = payload => ({
        type: types.GET_CLASSES_BY_DATE_RANGE_SUCCESS,
        payload,
    });

    static getClassesByDateRangeFailed = error => ({
        type: types.GET_CLASSES_BY_DATE_RANGE_FAILED,
        payload: error,
    });

    // create class
    static createClassRequest = (classData, callback) => ({
        type: types.CREATE_CLASS_REQUEST,
        meta: { classData, callback },
    });

    static createClassSuccess = () => ({
        type: types.CREATE_CLASS_SUCCESS,
    });

    static createClassFailed = payload => ({
        type: types.CREATE_CLASS_FAILED,
        payload,
    });

    static clearClassErrors = () => ({
        type: types.CLEAR_CLASS_ERRORS,
    });

    // update single class
    static updateClassRequest = (classId, classData, callback) => ({
        type: types.UPDATE_CLASS_REQUEST,
        meta: { classId, classData, callback },
    });

    static updateClassSuccess = () => ({
        type: types.UPDATE_CLASS_SUCCESS,
    });

    static updateClassFailed = payload => ({
        type: types.UPDATE_CLASS_FAILED,
        payload,
    });

    // delete single class
    static deleteClassRequest = (classId, callback) => ({
        type: types.DELETE_CLASS_REQUEST,
        meta: { classId, callback },
    });

    static deleteClassSuccess = () => ({
        type: types.DELETE_CLASS_SUCCESS,
    });

    static deleteClassFailed = payload => ({
        type: types.DELETE_CLASS_FAILED,
        payload,
    });

    // update class series
    static updateClassSeriesRequest = (seriesId, classData, callback) => ({
        type: types.UPDATE_CLASS_SERIES_REQUEST,
        meta: { seriesId, classData, callback },
    });

    static updateClassSeriesSuccess = () => ({
        type: types.UPDATE_CLASS_SERIES_SUCCESS,
    });

    static updateClassSeriesFailed = payload => ({
        type: types.UPDATE_CLASS_SERIES_FAILED,
        payload,
    });

    // delete class series
    static deleteClassSeriesRequest = (seriesId, callback) => ({
        type: types.DELETE_CLASS_SERIES_REQUEST,
        meta: { seriesId, callback },
    });

    static deleteClassSeriesSuccess = () => ({
        type: types.DELETE_CLASS_SERIES_SUCCESS,
    });

    static deleteClassSeriesFailed = payload => ({
        type: types.DELETE_CLASS_SERIES_FAILED,
        payload,
    });

    // get class bookers
    static getClassBookersRequest = classId => ({
        type: types.GET_CLASS_BOOKERS_REQUEST,
        meta: { classId },
    });

    static getClassBookersSuccess = payload => ({
        type: types.GET_CLASS_BOOKERS_SUCCESS,
        payload,
    });

    static getClassBookersFailed = payload => ({
        type: types.GET_CLASS_BOOKERS_FAILED,
        payload,
    });

    // get class members
    static getClassMembersRequest = classId => ({
        type: types.GET_CLASS_MEMBERS_REQUEST,
        meta: { classId },
    });

    static getClassMembersSuccess = payload => ({
        type: types.GET_CLASS_MEMBERS_SUCCESS,
        payload,
    });

    static getClassmembersFailed = payload => ({
        type: types.GET_CLASS_MEMBERS_FAILED,
        payload,
    });

    // check in user
    static checkInUserRequest = (classId, userId, planMemberId, callback) => ({
        type: types.CHECK_IN_USER_REQUEST,
        meta: { classId, userId, planMemberId, callback },
    });

    static checkInUserSuccess = userId => ({
        type: types.CHECK_IN_USER_SUCCESS,
        payload: userId,
    });

    static checkInUserFailed = payload => ({
        type: types.CHECK_IN_USER_FAILED,
        payload,
    });

    // check out user
    static checkOutUserRequest = (classId, userId, planMemberId, callback) => ({
        type: types.CHECK_OUT_USER_REQUEST,
        meta: { classId, userId, planMemberId, callback },
    });

    static checkOutUserSuccess = userId => ({
        type: types.CHECK_OUT_USER_SUCCESS,
        payload: userId,
    });

    static checkOutUserFailed = payload => ({
        type: types.CHECK_OUT_USER_FAILED,
        payload,
    });

    // book class
    static bookClassRequest = classId => ({
        type: types.BOOK_CLASS_REQUEST,
        meta: { classId },
    });

    static bookClassSuccess = payload => ({
        type: types.BOOK_CLASS_SUCCESS,
        payload,
    });

    static bookClassFailed = payload => ({
        type: types.BOOK_CLASS_FAILED,
        payload,
    });

    // cancel class booking
    static cancelClassBookingRequest = classId => ({
        type: types.CANCEL_CLASS_BOOKING_REQUEST,
        meta: { classId },
    });

    static cancelClassBookingSuccess = payload => ({
        type: types.CANCEL_CLASS_BOOKING_SUCCESS,
        payload,
    });

    static cancelClassBookingFailed = payload => ({
        type: types.CANCEL_CLASS_BOOKING_FAILED,
        payload,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/ClassesActionCreators.js